import { DOMAIN } from './Dashboard.constants';
import get from 'lodash/get';
import { getPersistValue } from '/b2b/common/state/persist/Persist.selectors';

const emptyObject = {};

export const getStore = state => get(state, DOMAIN) || {};

export const getError = state => getStore(state).error;
export const getFilters = state => getStore(state).filters || {};
export const hasFilters = state =>
    Object.values(getFilters(state)).reduce(
        (hasFilters, filters) => hasFilters || filters.length,
        false
    );

export const isLoading = state => getStore(state).loading;

export const getPersistedDashboardState = state =>
    getPersistValue(state, 'uc.dashboard', emptyObject);

export const getPersistedPrivacyProtocolListState = state =>
    getPersistValue(state, 'uc.privacyProtocolList', emptyObject);

export const getPersistedUCConfigListState = state =>
    getPersistValue(state, 'uc.configList', emptyObject);

export const getPersistedConsumerSsoListState = state =>
    getPersistValue(state, 'uc.consumerSsoList', emptyObject);

export const getPersistedIntegrationsListState = state =>
    getPersistValue(state, 'uc.integrationsList', emptyObject);
